import { useState } from 'react';

import { useProject } from '../projects/context';
import { DocumentRequestPanel } from '../requests/DocumentRequestPanel';
import { ExposePanel } from '../expose/ExposePanel';
import { AttachmentsPanel } from './AttachmentsPanel';
import { DocumentsPanel } from './DocumentsPanel';

// DocumentsArea: Dokumente, Objektunterlagen und Exposé in einem Abschnitt (am Lead und am Termin) – statt drei
// gleich aufgebauter Karten mit je einem roten Knopf untereinander.
export function DocumentsArea({ leadId, appointmentId, collapsed }: { leadId: string; appointmentId?: string; collapsed?: boolean }) {
  const { can } = useProject();
  const readOnly = !can('document.edit');
  const [open, setOpen] = useState(false);
  const panels = (
    <>
      <AttachmentsPanel leadId={leadId} appointmentId={appointmentId} />
      <DocumentsPanel leadId={leadId} appointmentId={appointmentId} embedded />
      <DocumentRequestPanel leadId={leadId} embedded />
      <ExposePanel leadId={leadId} embedded />
    </>
  );
  if (collapsed ?? readOnly)
    return (
      <section className="card doc-area doc-area-readonly" aria-labelledby={`doc-area-${leadId}`}>
        <div className="section-head">
          <h2 id={`doc-area-${leadId}`}>Dokumente &amp; Unterlagen</h2>
          <button type="button" className="btn btn-small btn-ghost" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
            {open ? 'Einklappen' : 'Anzeigen'}
          </button>
        </div>
        {open ? panels : <p className="muted">{readOnly ? 'Fotos, Dateien, Dokumente und Exposé – zum Ansehen.' : 'Fotos, Dateien, Dokumente und Exposé.'}</p>}
      </section>
    );
  return (
    <section className="card doc-area" aria-labelledby={`doc-area-${leadId}`}>
      <h2 id={`doc-area-${leadId}`}>Dokumente &amp; Unterlagen</h2>
      {panels}
    </section>
  );
}
